<<template>  
  <prop-panel @close="close">
    <p slot="header">{{rs["create"]}}</p>
    
    <div class="row" style="margin-left:0">
        <div class="input-group col-md-10" style="margin-left:0">
          <span class="input-group-addon" >{{rs["xdate"]}}</span>
          <DatePicker type="daterange" :editable="false" style="width: 250px" ghost
          placement="bottom-end" placeholder="Select date" v-model="rq" format="yyyy-MM-dd"></DatePicker>
        </div>
    </div>
    <!--div class="row" style="margin-left:0">
        <div class="input-group col-md-5" style="margin-left:0">
          <span class="input-group-addon" >{{rs["xdate1"]}}</span>
            <date-input :formater='"yyyy-MM-dd"' class="form-control" v-model="rq1"/>
        </div>
        <div class="input-group col-md-5" style="margin-left:0">
          <span class="input-group-addon" >{{rs["xdate2"]}}</span>
            <date-input :formater='"yyyy-MM-dd"' class="form-control" v-model="rq2"/>
        </div-->
      <label><input v-model="xbc" type="checkbox" checked="checked" value="1">{{rs["zdbc"]}}</label>
      <div v-show="xbc==1" class="input-group">
        <span class="input-group-addon" >班次</span>
          <select v-model="xbcv" class="form-control">
            <option v-for="item in bcs" :value="item.shiftNo">{{item.shiftName + " (" + item.shiftNo + ")"}}</option>
          </select>
      </div>
      <br>
      <label style="display: none"><input v-model="gnLock" type="checkbox" value="1">{{rs["ncfLock"]}}</label>
    </div>
    <div class="row" style="margin-left:0">
      <label><input v-model="gnTarget" type="radio" name="createTypex" value="1" checked="checked">全部员工</label>
      <label><input v-model="gnTarget" type="radio" name="createTypex" value="2" >按部门</label>
      <label><input v-model="gnTarget" type="radio" name="createTypex" value="3" >按员工</label>

      <div v-show="gnTarget==2" class="input-group">
        <span class="input-group-addon">部门</span>
          <select v-model="dept" name="bmmc" class="form-control">
            <option v-for="item in depts" :value="item.bmbh">{{item.bmmc}}</option>
          </select>
      </div>
      
      <div v-show="gnTarget==3" style="margin: 1px; height: 190px;">
        <div class="input-group col-md-10">
          <input ref="gnNo" v-model="gnNo" @keyup.enter="onEnter" type="text" class="form-control">
          <div class="input-group-btn">
            <button @click.stop="onEnter" class="btn btn-default">添加</button>
            <button @click.stop="clear" class="btn btn-default">清除全部</button>
          </div>
        </div>
        <select size="10" style="width: 500px; height: 150px; margin-left:17px;">
          <option v-for="(item, idx) in gnList" :value="item.empId" @dblclick.stop="removeItem(idx)">{{item.empId}}  {{item.empName}}</option>
        </select>
      </div>
    </div>
    <div slot="footer">
      <button @click.stop="close" type="button" class="btn btn-default" data-dismiss="modal">{{rs["btn_close"]}}</button>
      <button @click.stop="generate" type="button" class="btn btn-primary">{{rs["create"]}}</button>
    </div>
  </prop-panel>
</template>

<<script>
export default {
  created: function() {
    //const dt = this.$dateNow()
    this.rq1=this.bdate
    this.rq2=this.edate
  },
  props:["bcs", "depts", "rs", "url", "bdate", "edate"],
  data(){
    return {
      rq: null,
      rq1:null,
      rq2:null,
      xbc:null,
      xbcv: this.bcs[0].shiftNo,
      gnTarget: 3,
      gnLock: null,
      gnType:1,
      gnNo: null,
      gnList:[],
      dept: null
    }
  },
  methods:{
    close: function() {
      this.$emit("close")
    },
    onEnter(){
      const dt = this.gnList.filter(d=>{
        return d.bh==this.gnNo || d.xm==this.gnNo
      })
      if (dt.length>0) {
        this.$refs.gnNo.select()
        return
      } 
      this.$getData(this.url+"GetUser?No=" + this.gnNo, data=>{
        if (data.rs==1){
          this.gnList.push(data.emp)
          this.gnNo=""
        }
        else{
          this.$alert(this.rs["notFound"])
          this.$refs.gnNo.select()
        }
      })
    },
    removeItem(idx){
        this.gnList.splice(idx,1)
    },
    clear(){
      this.gnList = []
      this.$refs.gnNo.select()
    },
    generate(){
      if (!this.rq || this.rq[0]==""){
        this.$alert(this.rs["nullDate"])
        return
      }
       /* if (this.$trim(this.rq1) == "" || this.$trim(this.rq2) == ""){
            this.$alert(this.rs["nullGDate"])
            return 
        } */

        if (this.xbc && !this.xbcv) {
            this.$alert(this.rs["nullXbc"])
            return 
        }
        if (this.gnTarget == 2 && !this.dept){
            this.$alert(this.rs["nullDept"])
            return 
        }
        if (this.gnTarget==3 && this.gnList.length<=0) {
            this.$alert(this.rs["nullGn"])
            return 
        }
        const obj = {
          //rq1: this.rq1,
          //rq2: this.rq2,
          rq1: this.rq[0],
          rq2: this.rq[1],
            fillTarget: this.gnTarget,
            fc: this.gnLock,
            bc: this.xbc? this.xbcv : null,
            dept: this.dept,
            gn: []
        }
        if (this.gnTarget == 1){
          this.dept= null
          this.gn=[]
        }
        else{
          this.gnList.forEach(d=>{
            obj.gn.push(d.empId)
          })
        }

        this.$postData(this.url + "generateAtt", obj, data=>{
          if (data.rs == 1) { if (this.$confirm("生成成功\r\n是否返回列表界面？")) this.$emit("close")}
          else if (data.rs==-9) this.$alert("日报表正在生成中，请稍后再试！")
          else this.$sysError()
        })
    }
  }
}
</script>
